/**
 * Ghi nhớ "lần thu này có gửi email nhập học" giữa lúc CÁN BỘ TÍCH Ô XÁC NHẬN và lúc
 * BIÊN LAI RA.
 *
 * ⚠ Vì sao không để trong state/ref của màn Thu tiền: tạo biên lai xong reducer đặt
 * `step: 2` -> component ThuTien BỊ GỠ ngay, mọi ref/effect trong đó mất theo, nên cờ đặt
 * ở đó không còn ai đọc được. Để ở tầng module thì saga (và cả luồng QR) đều lấy được.
 */
const dsChoGui = new Set<string>();

export const datChoGuiEmailNhapHoc = (id_sv: string, gui: boolean) => {
  if (!id_sv) return;
  if (gui) dsChoGui.add(id_sv);
  else dsChoGui.delete(id_sv);
};

/** Lấy cờ VÀ xóa luôn — mỗi lần thu chỉ gửi 1 lần. */
export const layVaXoaChoGuiEmailNhapHoc = (id_sv: string): boolean => {
  if (!id_sv || !dsChoGui.has(id_sv)) return false;
  dsChoGui.delete(id_sv);
  return true;
};
